import React, { useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const MonthlyStockReport = () => {
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both dates");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
  `${REACT_APP_API_URL}api/inventory-report/monthly-report`,
  {
    fromDate,
    toDate
  }
);

setData(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.log(error);
      alert("Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="row mb-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Monthly Wise Stock Report</h3>
          </div>
        </div>
      </div>

      <div className="row mb-4 align-items-end">
        <div className="col-md-3">
          <label>From Date</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <label>To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="col-md-2">
          <button
            className="btn btn-primary w-100"
            onClick={fetchData}
          >
            {loading ? "Loading..." : "Show"}
          </button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>Month</th>
              <th>Total Request</th>
              <th>Total Dispatch</th>
              <th>Total Receive</th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((item, i) => (
                <tr key={i}>
                  <td>{item.MonthName}</td>
                  <td>{item.TotalRequest}</td>
                  <td>{item.TotalDispatch}</td>
                  <td>{item.TotalReceive}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MonthlyStockReport;